// Genera el PDF del deslinde "genérico" (sin atleta específico, para
// imprimir copias en blanco) desde el panel admin. Misma estructura HTML +
// jsPDF que usa RegistryConfirmationPdfPreview.jsx en la app de atletas para
// el deslinde real, pero con un título arriba, espacio en blanco para que
// el atleta anote su nombre y número, y una línea en blanco donde iría la
// firma en vez de un nombre real.
import jsPDF from "jspdf";
import { sustituirPlaceholders } from "./deslindeTextos";

const LINEA_EN_BLANCO_FIRMA = "_________________________________";
const LINEA_EN_BLANCO_CAMPO = "_____________________________";
const MARGEN = 20;
const BORDE_DERECHO = 190;

const ESTILO = `
  <style>
    .fuente{
      font-size:11px;
      font-family:arial;
      margin-top:1px;
      padding-top:1px;
    }
  </style>
`;

function bloqueAvisoYCapacidad(textoAvisoConLink) {
  return `
    <div class="fuente">${textoAvisoConLink}</div>
    <div class="fuente">
      Al realizar mi inscripción en este evento declaro que me encuentro en plena capacidad física
      para participar en el mismo y deslindo de cualquier responsabilidad a las empresas organizadoras
      y patrocinadoras así como a sus representantes, de cualquier lesión o accidente como consecuencia
      de mi participación en el evento.
    </div>
  `;
}

function htmlGenericoMayores(textoAvisoConLink, textoLegalConEvento) {
  return `
    ${ESTILO}
    ${bloqueAvisoYCapacidad(textoAvisoConLink)}
    <div class="fuente">${textoLegalConEvento}</div>
    <div class="fuente">Tipo de ID ______________________</div>
    <div class="fuente">_______________________________________________________</div>
    <div class="fuente">Firma <b>${LINEA_EN_BLANCO_FIRMA}</b></div>
  `;
}

function htmlGenericoMenores(textoAvisoConLink, textoLegalConEvento) {
  return `
    ${ESTILO}
    ${bloqueAvisoYCapacidad(textoAvisoConLink)}
    <div class="fuente">${textoLegalConEvento}</div>
    <div class="fuente">Tipo de ID ______________________</div>
    <div class="fuente">Atleta representado: <b>${LINEA_EN_BLANCO_FIRMA}</b></div>
    <div class="fuente">_________________________________________________________</div>
    <div class="fuente">Nombre Completo del Padre o Tutor (escrito a mano)</div>
    <div class="fuente">_________________________________________________________</div>
    <div class="fuente">Firma</div>
    <div class="fuente">
      EN TESTIMONIO DE FE, COMO RESPONSABLES DEL COMPETIDOR INSCRITO, NOSOTROS COMO PADRES O TUTORES,
      DECLARAMOS HABER ENTENDIDO LO ANTERIORMENTE DESCRITO Y AÑADIMOS LA FIRMA EN FORMA VOLUNTARIA.
    </div>
  `;
}

// Título + espacio para que el atleta anote a mano su nombre y número,
// dibujado directamente con doc.text()/doc.line() (no es parte del HTML de
// abajo), dejando el margen superior para que fromHTML empiece después. La
// línea del nombre es una línea dibujada (doc.line), no texto con guiones,
// para que llegue exactamente hasta el borde derecho de la página.
function dibujarEncabezado(doc, nombreEvento) {
  doc.setFont("times");
  doc.setFontType("bold");
  doc.setFontSize(16);
  doc.text(MARGEN, 20, "Deslinde de responsabilidades");
  doc.text(MARGEN, 28, nombreEvento || "");

  doc.setFont("times");
  doc.setFontType("normal");
  doc.setFontSize(11);
  doc.text(MARGEN, 40, "Nombre:");
  doc.setLineWidth(0.2);
  doc.line(38, 41, BORDE_DERECHO, 41);

  doc.text(MARGEN, 49, `Número de participante: ${LINEA_EN_BLANCO_CAMPO}`);

  doc.setLineWidth(0.3);
  doc.line(MARGEN, 53, BORDE_DERECHO, 53);
}

// textoAviso / textoLegal: el texto (guardado o default) tal cual está en el
// textarea, puede traer los placeholders "{nombreEvento}"/"{linkAvisoPrivacidad}"
// sin sustituir.
export function generarPdfDeslindeGenerico({
  nombreEvento,
  linkAvisoPrivacidad,
  textoAviso,
  textoLegal,
  esMenor,
}) {
  const doc = new jsPDF("p", "mm", "letter");

  dibujarEncabezado(doc, nombreEvento);

  const textoAvisoConLink = sustituirPlaceholders(textoAviso, {
    nombreEvento,
    linkAvisoPrivacidad,
    negritas: true,
  });
  const textoConEvento = sustituirPlaceholders(textoLegal, {
    nombreEvento,
    negritas: true,
  });

  const html = esMenor
    ? htmlGenericoMenores(textoAvisoConLink, textoConEvento)
    : htmlGenericoMayores(textoAvisoConLink, textoConEvento);

  doc.fromHTML(html, 20, 58, { width: 180 });
  return doc;
}

export function descargarPdfDeslindeGenerico(params) {
  const doc = generarPdfDeslindeGenerico(params);
  const tipo = params.esMenor ? "menores de edad" : "mayores de edad";
  doc.save(
    `Deslinde generico (${tipo}) - ${params.nombreEvento || "evento"}.pdf`
  );
}
